/**
 * @fileoverview > handler for the "/engagement/campaigns" endpoint
 */
import type { CampaignPost } from "@schemas/types";

import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCampaignCacheKeys } from "./constants";
import type { PostCampaignDataResponse } from "./types";

export const postCampaign = reactQueryMutationAdapter(
  postCampaignCacheKeys,
  (props: CampaignPost): Promise<PostCampaignDataResponse> => {
    return fetch(`/engagement/campaigns`, "POST", props, {}, { propagateFetchRequestError: false });
  }
);
